import { useIntlLocale } from "@frontend/hooks/useIntlLocale";
import { plural } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import type { Absence } from "../types";
import { isNewAbsence } from "../utils/draft";
import { formatRange } from "../utils/format";

export type AbsenceSameCaseLabelProps = {
  absence: Absence | undefined;
};

export function AbsenceSameCaseLabel({ absence }: AbsenceSameCaseLabelProps) {
  const { t } = useLingui();
  const locale = useIntlLocale();

  if (!absence) {
    return <>{"?"}</>;
  }

  const range = formatRange(absence.beginDate, absence.endDate, locale) || "?";
  const label = t`${absence.typeLabel ?? "?"} – ${range} (${plural({ dayCount: absence.dayCount }, { one: "# day", other: "# days" })})`;

  if (isNewAbsence(absence.id)) {
    return (
      <>
        {label} <em>{t`not saved yet`}</em>
      </>
    );
  }

  return <>{label}</>;
}
